/**
 * Copy text to the clipboard.
 *
 * The async clipboard API is rejected by some browsers once the copy no longer
 * happens in the same task as the user gesture, which is the case whenever the
 * text has to be fetched first - hence the legacy fallback.
 */
export const copyToClipboard = (text) => {
  if (!text) return false;

  const legacyCopy = () => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  };

  try {
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).catch(legacyCopy);
    } else {
      legacyCopy();
    }
    return true;
  } catch (err) {
    console.log("Error", err);
    return false;
  }
};
